import { Props as AddressModalProps } from "components/front/member/AddressDialog";
import { FieldProps } from "formik";
import { Address } from "interfaces/front/business";
import { useActivation } from "lib/hooks/useActivation";
import { OrderCreateInput } from "lib/service/client/FrontOrderService";
import dynamic from "next/dynamic";
import React, { FC, useContext } from "react";
import { SsDialogOpenButton } from "../../layout/SsDialogOpenButton";
import GrayBlock from "components/front/order/literal/GrayBlock";
import { AddressCard } from "./RecipientCard";
import EnhancedEcommerceContext from "lib/contexts/EnhancedEcommerceContext";
import styled from "styled-components";
import ErrorBlock from "components/front/order/literal/ErrorBlock";

const AddressModal = dynamic<AddressModalProps>(() => import("components/front/member/AddressDialog"));

export type Props = FieldProps<OrderCreateInput> & { courseIds: number[] };
const AddressField: FC<Props> = ({ field, form: { values, errors, setFieldValue }, courseIds }) => {
  const { triggerRecipientEvent } = useContext(EnhancedEcommerceContext.OrderForm);
  const [isOpen, open, close] = useActivation(false);
  const recipient = values[field.name];
  const openDialog = () => {
    open();
    triggerRecipientEvent().catch(console.error);
  };
  const onInput = (inputAddress?: Address): void => {
    if (inputAddress) {
      setFieldValue(field.name, inputAddress);
    }
    close();
  };
  return (
    <>
      <GrayBlock>お届け先は注文確定するまで保存されません。</GrayBlock>
      <div>
        {errors[field.name] ? (
          <StyledErrorBlock>お届け先を入力してください</StyledErrorBlock>
        ) : (
          <AddressCard address={recipient} />
        )}
        <SsDialogOpenButton label="お届け先を入力する" onClick={openDialog} margin="20px auto" />
        <AddressModal isOpen={isOpen} initialValue={recipient} closeHandle={onInput} courseIds={courseIds} />
      </div>
    </>
  );
};
export default AddressField;

const StyledErrorBlock = styled(ErrorBlock)`
  margin: 14px 0;
`;
